module.exports = __webpack_public_path__ + "07_mole.ccd99c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/07_mole.png
// module id = eA8h
// module chunks = 0